import { Upload } from "@portal/BaseComponents/Upload/AntUpload";
import { Files } from "@portal/types/file";
import styled from "styled-components";

export const StyledDocUpload = styled(Upload<Files>)`
  &.uploaded {
    .ant-upload-list {
      margin-top: 0;
    }
  }
  .ant-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-8);
    justify-content: flex-start;

    /* Only apply margin when there are file items */
    &:has(.ant-upload-list-item-container) {
      margin-top: var(--space-16);
    }

    &::before {
      content: none;
    }

    .ant-upload-list-item-container {
      height: 40px;
    }
  }
`;
